export default __webpack_public_path__ + "static/media/Polygon1.f6e8ebdb.svg";